import { CartItemDialog } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/CartItemDialog';
import { useCartItemState } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCartItemState';
import { CartItemDialogFormSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/CartItemDialogFormSchema';
import { CartFormActions } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/CartFormActions';
import { FormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/FormItem';
import { MinimalFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/MinimalFormItem';
import { FormWrapper } from '@/components/shared/components/FormWrapper';

export interface CartItemDialogProps {
  index: number;
  items: MinimalFormItem[];
  cartFormActions: CartFormActions;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const CartItemDialogWrapper = ({ index, items, cartFormActions, open, setOpen }: CartItemDialogProps) => {
  const { initialFormItem } = useCartItemState({ items, index });

  return (
    <FormWrapper
      formSchema={CartItemDialogFormSchema}
      defaultValues={{
        item: initialFormItem as FormItem,
      }}
    >
      <CartItemDialog index={index} items={items} cartFormActions={cartFormActions} open={open} setOpen={setOpen} />
    </FormWrapper>
  );
};
